import { ProfilePhotoStatus } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";
import { IsDate, IsDefined, IsString, IsUUID } from "class-validator";
import { v4 as uuid } from "uuid";

import { statusGetter } from "../statusGetter";
import { TransformToDate } from "../transformers/transformToDate";

@Exclude()
export class ProfilePhoto {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public fileId: string = uuid();

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public optimizedFileId?: string;

    @IsDate()
    @TransformToDate
    @Expose()
    public acceptedAt?: Date;

    @IsDate()
    @TransformToDate
    @Expose()
    public declinedAt?: Date;

    @IsString()
    @Expose()
    public declinationReason?: string;

    public get status(): ProfilePhotoStatus {
        return statusGetter(this, ProfilePhoto, ProfilePhotoStatus);
    }

    public static statusPrototype(status: ProfilePhotoStatus): ProfilePhoto {
        const defined = new Date();

        switch (status) {
            case ProfilePhotoStatus.Declined:
                return { declinedAt: defined } as ProfilePhoto;

            case ProfilePhotoStatus.Accepted:
                return {
                    acceptedAt: defined,
                    declinedAt: undefined,
                } as ProfilePhoto;

            case ProfilePhotoStatus.Pending:
            default:
                return {
                    declinedAt: undefined,
                    acceptedAt: undefined,
                } as ProfilePhoto;
        }
    }
}
